import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, getToken, setToken } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [quota, setQuota] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    if (!getToken()) {
      setUser(null);
      setLoading(false);
      return;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      setQuota(data.quota);
    } catch (_) {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
    const onLogout = () => {
      setUser(null);
      setQuota(null);
    };
    window.addEventListener("ke:logout", onLogout);
    return () => window.removeEventListener("ke:logout", onLogout);
  }, [refresh]);

  const login = (token, u) => {
    setToken(token);
    setUser(u);
    refresh();
  };

  const logout = () => {
    setToken(null);
    setUser(null);
    setQuota(null);
  };

  return (
    <AuthContext.Provider value={{ user, quota, loading, login, logout, refresh, isAdmin: user?.role === "admin" }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
